import { render, staticRenderFns } from "./m-chain-price.vue?vue&type=template&id=d1444af0&scoped=true&"
import script from "./m-chain-price.vue?vue&type=script&lang=ts&"
export * from "./m-chain-price.vue?vue&type=script&lang=ts&"
import style0 from "./m-chain-price.vue?vue&type=style&index=0&id=d1444af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1444af0",
  null
  
)

export default component.exports